
{
  "familyId": "GET-BREUK-MIN",
  "questions": [
    {
      "id": "GET-BREUK-MIN-001",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{5}{6}$ - $\\frac{2}{6}$ =",
      "options": ["$\\frac{3}{6}$", "$\\frac{3}{12}$", "$\\frac{7}{6}$", "$\\frac{5}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 5, "denominator": 6, "label": "5/6"},
              {"numerator": 2, "denominator": 6, "label": "2/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 6,
            "label": "5/6 - 2/6 = 3/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij gelijknamige breuken trek je alleen de tellers van elkaar af — de noemer blijft hetzelfde. Tellers: 5 - 2 = 3. De noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$. Controleer: $\\frac{3}{6}$ + $\\frac{2}{6}$ = $\\frac{5}{6}$ ✓.",
        "solutionSteps": [
          "Controleer: de noemers zijn gelijk (beide 6) → gelijknamige breuken",
          "Trek de tellers af: 5 - 2 = 3",
          "De noemer blijft 6",
          "Antwoord: $\\frac{3}{6}$",
          "Controleer: $\\frac{3}{6}$ + $\\frac{2}{6}$ = $\\frac{5}{6}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 5 - 2 = 3, noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (6 + 6 = 12). Maar bij gelijknamige breuken blijft de noemer hetzelfde — je trekt alleen de tellers af. Onthoud: de noemer verandert niet bij gelijknamig aftrekken.",
          "2": "Je hebt de tellers opgeteld (5 + 2 = 7) in plaats van afgetrokken. Let op het minteken: 5 - 2 = 3, niet 5 + 2 = 7. Onthoud: bij aftrekken wordt het antwoord kleiner.",
          "3": "Je hebt de tweede breuk niet afgetrokken en de eerste breuk als antwoord gegeven. Trek de tellers af: 5 - 2 = 3. Onthoud: je moet de bewerking uitvoeren."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-002",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{7}{8}$ - $\\frac{3}{8}$ =",
      "options": ["$\\frac{4}{8}$", "$\\frac{4}{16}$", "$\\frac{10}{8}$", "$\\frac{3}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_eighths",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 7, "denominator": 8, "label": "7/8"},
              {"numerator": 3, "denominator": 8, "label": "3/8"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 8,
            "label": "7/8 - 3/8 = 4/8",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij gelijknamige breuken trek je alleen de tellers af. Tellers: 7 - 3 = 4. De noemer blijft 8. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$. Tip: $\\frac{4}{8}$ kun je vereenvoudigen tot $\\frac{1}{2}$.",
        "solutionSteps": [
          "Controleer: de noemers zijn gelijk (beide 8) → gelijknamige breuken",
          "Trek de tellers af: 7 - 3 = 4",
          "De noemer blijft 8",
          "Antwoord: $\\frac{4}{8}$ (= $\\frac{1}{2}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 7 - 3 = 4, noemer blijft 8. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook optelt (8 + 8 = 16). Maar bij gelijknamige breuken blijft de noemer hetzelfde. Onthoud: alleen de tellers veranderen, de noemer niet.",
          "2": "Je hebt de tellers opgeteld (7 + 3 = 10) in plaats van afgetrokken. Let op het minteken: 7 - 3 = 4, niet 7 + 3 = 10. Onthoud: bij aftrekken wordt het antwoord kleiner.",
          "3": "Je hebt per ongeluk de tweede breuk als antwoord gegeven in plaats van het verschil te berekenen. Trek de tellers af: 7 - 3 = 4. Onthoud: voer de bewerking uit."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-003",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{2}$ - $\\frac{1}{4}$ =",
      "options": ["$\\frac{1}{4}$", "$\\frac{0}{2}$", "$\\frac{2}{6}$", "$\\frac{1}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_unlike_fractions_basic",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 2, "label": "1/2"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "label": "1/2 = 2/4, dan 2/4 - 1/4 = 1/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (2 en 4), dus je moet ze eerst gelijknamig maken. $\\frac{1}{2}$ = $\\frac{2}{4}$ (teller en noemer ×2). Nu kun je aftrekken: $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Controleer: $\\frac{1}{4}$ + $\\frac{1}{4}$ = $\\frac{2}{4}$ = $\\frac{1}{2}$ ✓.",
        "solutionSteps": [
          "De noemers zijn ongelijk (2 en 4) → maak ze gelijknamig",
          "$\\frac{1}{2}$ = $\\frac{2}{4}$ (teller en noemer ×2)",
          "Trek de tellers af: 2 - 1 = 1",
          "Antwoord: $\\frac{1}{4}$",
          "Controleer: $\\frac{1}{4}$ + $\\frac{1}{4}$ = $\\frac{2}{4}$ = $\\frac{1}{2}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$.",
          "1": "Je hebt 1 - 1 = 0 berekend zonder de noemers gelijk te maken. De noemers zijn ongelijk: maak ze eerst gelijk. $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Onthoud: bij ongelijke noemers eerst gelijknamig maken.",
          "2": "Je hebt de noemers opgeteld (2 + 4 = 6). Dat mag niet bij breuken aftrekken. Maak de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Onthoud: noemers optellen is nooit correct.",
          "3": "Je hebt de noemers vermenigvuldigd (2 × 4 = 8). Dat is niet de juiste aanpak. Maak de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Onthoud: zoek de kleinste gemeenschappelijke noemer."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-004",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{2}{3}$ - $\\frac{1}{6}$ =",
      "options": ["$\\frac{3}{6}$", "$\\frac{1}{3}$", "$\\frac{1}{9}$", "$\\frac{2}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_unlike_fractions_thirds",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 2, "denominator": 3, "label": "2/3"},
              {"numerator": 1, "denominator": 6, "label": "1/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 6,
            "label": "2/3 = 4/6, dan 4/6 - 1/6 = 3/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (3 en 6), dus maak ze eerst gelijknamig. $\\frac{2}{3}$ = $\\frac{4}{6}$ (teller en noemer ×2). Nu kun je aftrekken: $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$. Controleer: $\\frac{3}{6}$ + $\\frac{1}{6}$ = $\\frac{4}{6}$ = $\\frac{2}{3}$ ✓.",
        "solutionSteps": [
          "De noemers zijn ongelijk (3 en 6) → maak ze gelijknamig",
          "$\\frac{2}{3}$ = $\\frac{4}{6}$ (teller en noemer ×2)",
          "Trek de tellers af: 4 - 1 = 3",
          "Antwoord: $\\frac{3}{6}$",
          "Controleer: $\\frac{3}{6}$ + $\\frac{1}{6}$ = $\\frac{4}{6}$ = $\\frac{2}{3}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{2}{3}$ = $\\frac{4}{6}$, dan $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "1": "Je hebt waarschijnlijk $\\frac{2}{3}$ - $\\frac{1}{3}$ = $\\frac{1}{3}$ gerekend, maar de tweede breuk is $\\frac{1}{6}$, niet $\\frac{1}{3}$. Maak de noemers gelijk: $\\frac{2}{3}$ = $\\frac{4}{6}$, dan $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$. Onthoud: lees de noemer goed.",
          "2": "Je hebt de noemers opgeteld (3 + 6 = 9). Dat mag niet. Maak de noemers gelijk: $\\frac{2}{3}$ = $\\frac{4}{6}$, dan $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$. Onthoud: noemers optellen is nooit correct bij breuken.",
          "3": "Je hebt $\\frac{2}{3}$ omgezet naar $\\frac{2}{6}$ — de noemer is verdubbeld maar de teller niet. Als je de noemer verdubbelt, moet je de teller ook verdubbelen: $\\frac{2}{3}$ = $\\frac{4}{6}$. Onthoud: teller en noemer altijd met hetzelfde getal vermenigvuldigen."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-005",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een kok heeft $\\frac{3}{4}$ kilo bloem. Hij gebruikt $\\frac{1}{3}$ kilo voor een recept. Hoeveel bloem heeft hij over?",
      "options": ["$\\frac{5}{12}$", "$\\frac{2}{1}$", "$\\frac{2}{12}$", "$\\frac{1}{4}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_unlike_fractions_context",
      "variantIndex": 5,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 3, "denominator": 4, "label": "3/4 kilo"},
              {"numerator": 1, "denominator": 3, "label": "1/3 kilo"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ongelijknamige breuken aftrekken",
            "content": "Zoek de kleinste gemeenschappelijke noemer. Voor 4 en 3 is dat 12. Zet beide breuken om: ¾ = 9/12 en ⅓ = 4/12. Trek af: 9/12 - 4/12 = 5/12.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (4 en 3). De kleinste gemeenschappelijke noemer is 12. $\\frac{3}{4}$ = $\\frac{9}{12}$ (×3) en $\\frac{1}{3}$ = $\\frac{4}{12}$ (×4). Trek af: $\\frac{9}{12}$ - $\\frac{4}{12}$ = $\\frac{5}{12}$. De kok heeft $\\frac{5}{12}$ kilo bloem over.",
        "solutionSteps": [
          "De noemers zijn ongelijk (4 en 3) → zoek de kleinste gemeenschappelijke noemer: 12",
          "$\\frac{3}{4}$ = $\\frac{9}{12}$ (teller en noemer ×3)",
          "$\\frac{1}{3}$ = $\\frac{4}{12}$ (teller en noemer ×4)",
          "Trek de tellers af: 9 - 4 = 5",
          "Antwoord: $\\frac{5}{12}$ kilo bloem over"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4}$ = $\\frac{9}{12}$ en $\\frac{1}{3}$ = $\\frac{4}{12}$. Dan $\\frac{9}{12}$ - $\\frac{4}{12}$ = $\\frac{5}{12}$.",
          "1": "Je hebt de tellers en noemers apart afgetrokken (3-1=2, 4-3=1). Dat mag niet bij breuken. Maak eerst de noemers gelijk. Onthoud: breuken kun je alleen aftrekken als de noemers gelijk zijn.",
          "2": "Je hebt de tellers afgetrokken (3-1=2) maar de noemers vermenigvuldigd (4×3=12). Dat klopt niet — als je de noemer verandert, moet je de teller ook aanpassen. $\\frac{3}{4}$ = $\\frac{9}{12}$, niet $\\frac{3}{12}$.",
          "3": "Je hebt waarschijnlijk alleen naar de eerste breuk gekeken. $\\frac{1}{4}$ is niet het verschil tussen $\\frac{3}{4}$ en $\\frac{1}{3}$. Maak de noemers gelijk: $\\frac{9}{12}$ - $\\frac{4}{12}$ = $\\frac{5}{12}$."
        }
      }
    }
  ]
}
